import { AssessmentComponent } from "./componentTypes";
import {
	ComponentConditionType,
	ConditionABCD,
	ConditionAC,
	ConditionBlurryDots,
	ConditionCosmetic,
	ConditionFaultyWorking,
	ConditionMaterial,
	ConditionNoYes,
	ConditionOverall,
	ConditionYesNo,
} from "./conditions";

export const ConditionsMapV2: Record<AssessmentComponent, ComponentConditionType> = {
	"self-camera-cosmetics": ConditionCosmetic,
	"self-back-cosmetics": ConditionCosmetic,
	"self-body-frame-cosmetics": ConditionCosmetic,
	"self-lcd-condition": ConditionNoYes,
	"self-front-cosmetics": ConditionCosmetic,
	"self-device-turns-on": ConditionYesNo,
	"self-device-skin": ConditionNoYes,
	"question-body-frame": ConditionCosmetic,
	"question-screen-blemishes": ConditionNoYes,
	biometrics: ConditionFaultyWorking,
	"front-camera-ai": ConditionBlurryDots,
	gyroscope: ConditionFaultyWorking,
	multitouch: ConditionFaultyWorking,
	audio: ConditionFaultyWorking,
	"back-camera-ai": ConditionBlurryDots,
	digitizer: ConditionFaultyWorking,
	"grader-camera-cosmetics": ConditionCosmetic,
	"grader-front-cosmetics": ConditionCosmetic,
	"grader-body-frame-cosmetics": ConditionCosmetic,
	"grader-lcd-condition": ConditionNoYes,
	"grader-back-cosmetics": ConditionCosmetic,
	"grader-device-skin": ConditionNoYes,
	"self-charger": ConditionYesNo,
	"self-device-material": ConditionMaterial,
	"self-overall-condition": ConditionOverall,
	"self-strap": ConditionYesNo,
	"self-buttons-work": ConditionYesNo,
};

export const ConditionsMapV3: Record<AssessmentComponent, ComponentConditionType> = {
	"self-camera-cosmetics": ConditionABCD,
	"self-back-cosmetics": ConditionABCD,
	"self-body-frame-cosmetics": ConditionABCD,
	"self-lcd-condition": ConditionAC,
	"self-front-cosmetics": ConditionABCD,
	"self-device-turns-on": ConditionYesNo,
	"self-device-skin": ConditionNoYes,
	"question-body-frame": ConditionABCD,
	"question-screen-blemishes": ConditionAC,
	biometrics: ConditionFaultyWorking,
	"front-camera-ai": ConditionBlurryDots,
	gyroscope: ConditionFaultyWorking,
	multitouch: ConditionFaultyWorking,
	audio: ConditionFaultyWorking,
	"back-camera-ai": ConditionBlurryDots,
	digitizer: ConditionFaultyWorking,
	"grader-camera-cosmetics": ConditionABCD,
	"grader-front-cosmetics": ConditionABCD,
	"grader-body-frame-cosmetics": ConditionABCD,
	"grader-lcd-condition": ConditionAC,
	"grader-back-cosmetics": ConditionABCD,
	"grader-device-skin": ConditionNoYes,
	"self-charger": ConditionYesNo,
	"self-device-material": ConditionMaterial,
	"self-overall-condition": ConditionOverall,
	"self-strap": ConditionYesNo,
	"self-buttons-work": ConditionYesNo,
};
